<template>
  <div class="text-gray-600" style="padding:10px 0 10px 10px; width: calc(100% - 10px); background-color: #f5faf3;">
    <hr style="border-color: #fafbfb;" />
    <div style="display: flex; justify-content: space-between; margin-top:10px;">
      <div>
        <b class="text-gray-700">지피테라퓨틱스코리아 주식회사</b>
        <br/>(ZP Therapeutics Korea Co.,Ltd.)
        <br/>
        서울특별시 용산구 한강대로 92, LS용산타워 3층
        <br/>
        <b class="text-gray-700">소비자 상담실:</b> <a href="tel:16883960">1688-3960</a>
        <br/>
        <a href="#" @click="openPrivacyPolicy"><u class="text-gray-600">개인정보 처리방침</u></a>
        <PrivacyPolicyDialog ref="PrivacyPolicyDialog" />
      </div>
      <img src="@/assets/images/zplab/logo.png" alt="" height="50px">
    </div>
  </div>
</template>
<script>
import PrivacyPolicyDialog from './dialog/PrivacyPolicyDialog.vue';

export default {
  components: {
    PrivacyPolicyDialog,
  },
  methods: {
    openPrivacyPolicy() {
      this.$refs.PrivacyPolicyDialog.open('');
    }
  }
}
</script>
<style lang="scss">
</style>
